import ApiClient from './apiClient'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSlackOauth = async (code: string): Promise<any> => ApiClient.post(
  '/api/v1/renderer/slack/oauth',
  (result) => result,
  { code: code },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteSlackOauth = async (): Promise<any> => ApiClient.delete(
  '/api/v1/renderer/slack/oauth',
  () => {
    // do nothing
  },
)
